import {
  PreferenceScope,
  UserPreferenceKey,
} from '../../../../shared/user-preferences';
import { PreferenceBrowserStorage } from '../../../../shared/user-preferences/utils/preference-session-storage';
import { getGeographyDefaultSelectionsForTaxonomy } from './getGeographyDefaultSelectionsForTaxonomy';

/**
 * Switch the user's GLOBAL geography taxonomy preference.
 *
 * TWO writes, always together:
 *
 * 1. The taxonomy choice itself (GLOBAL / `Geography`).
 * 2. The GEOGRAPHY-scope `DefaultFilters` regeneration.
 *
 * (2) is not optional. The two taxonomies share NO entity ids, so a default
 * carried over from the outgoing taxonomy selects nothing in the incoming one
 * — the page lands on a primary filter that resolves to an empty set. Every
 * switch surface (the preferences modal, the in-tree
 * `GeographyTaxonomyBranchLabel`, and the assistant's inline
 * `[…](offer:geo_tax)` narration link) therefore funnels through here rather
 * than writing the preference directly.
 *
 * `version` is omitted when the caller doesn't know it (the assistant's
 * mismatch metadata carries only an id), in which case the backend resolves
 * the latest — the behaviour every geography tree query has always had.
 */
export const applyGeographyTaxonomyPreference = (
  nextTaxonomyId: number,
  version?: string
): void => {
  PreferenceBrowserStorage.update(
    PreferenceScope.GLOBAL,
    UserPreferenceKey.Geography,
    { taxonomyId: nextTaxonomyId, ...(version ? { version } : {}) }
  );
  PreferenceBrowserStorage.update(
    PreferenceScope.GEOGRAPHY,
    UserPreferenceKey.DefaultFilters,
    getGeographyDefaultSelectionsForTaxonomy(nextTaxonomyId)
  );
};
